import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ResourceService } from '../../service/resource.service';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent {
    constructor(private cookieService: CookieService, private resourceService: ResourceService) { };
}
